import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component'
import { PagesLayoutComponent } from './Layout/pages-layout/pages-layout.component'
import { AcompanharPtComponent } from './pages/pt/acompanhar-pt/acompanhar-pt.component'
import { AcompanharSSComponent } from './pages/ss/acompanhar-ss/acompanhar-ss.component'

import { AvaliarSSComponent } from './pages/ss/avaliar-ss/avaliar-ss.component'
import { EmitirOSComponent } from './pages/os/emitir-os/emitir-os.component'
import { HomeComponent } from './pages/home/home.component'
import { LoginPageComponent } from './pages/acesso/login-page/login-page.component'
import { ProgramarServicoComponent } from './pages/programarServico/programar-servico.component'
import { CadastrarPTComponent } from './pages/pt/cadastro-pt/cadastrar-pt.component'
import { ListaPTComponent } from './pages/pt/lista-pt/lista-pt.component'
import { SolicitarPtComponent } from './pages/pt/solicitar-pt/solicitar-pt.component'
import { SolicitarSSCadastrarComponent } from './pages/ss/solicitar-ss/solicitar-ss-cadastrar.component'
import { SolicitarSSListaComponent } from './pages/ss/solicitar-ss/solicitar-ss-lista.component'
import { SolicitarSSComponent } from './pages/ss/solicitar-ss/solicitar-ss.component'
import { UsuarioPageComponent } from './pages/acesso/usuario-page/usuario-page.component'
import { AuthService } from './services/auth.service'
import { ConsultarOsComponent } from './pages/os/consultar-os/consultar-os.component'
import { DashboardComponent } from './pages/dashboard/dashboard.component'
import { IrregularidadeComponent } from './pages/cadastros/irregularidade/irregularidade.component'
import { EmpreiteiraComponent } from './pages/cadastros/empreiteira/empreiteira.component'
import { FecharOsComponent } from './pages/os/fechar-os/fechar-os.component'
import { FabricanteComponent } from './pages/cadastros/fabricante/fabricante.component'
import { MaterialComponent } from './pages/cadastros/material/material.component'
import { CategoriaComponent } from './pages/cadastros/categoria/categoria.component'
import { FuncionarioComponent } from './pages/cadastros/funcionario/funcionario.component'
import { EquipamentoComponent } from './pages/equipamento/equipamento.component'
import { LocalComponent } from './pages/cadastros/local/local.component'
import { AreaTecnicaComponent } from './pages/cadastros/areatecnica/areatecnica.component'

import { RotinaComponent } from './pages/cadastros/rotina/rotina.component'
import { AtividadeComponent } from './pages/cadastros/atividade/atividade.component'
import { EmitirOsAutomaticaComponent } from './pages/os/emitir-os-automatica/emitir-os-automatica.component'

import { NotAuthorizedComponent } from './errors/not-authorized/not-authorized.component'
import { UnderConstructionComponent } from './errors/under-construction/under-construction.component'
import { NotFoundComponent } from './errors/not-found/not-found.component'

import { FuncionalidadesComponent } from './pages/acesso/funcionalidades/funcionalidades.component'
import { UsuarioAlterarSenhaPageComponent } from './pages/acesso/usuario-page/usuario-alterar-senha-page.component'
import { EstoqueComponent } from './pages/cadastros/estoque/estoque.component'
import { ClasseEquipamentoComponent } from './pages/cadastros/classe-equipamento/classe-equipamento.component'
import { GrupoLocalNivelComponent } from './pages/cadastros/grupo-local-nivel/grupo-local-nivel.component'
import { CentroCustoComponent } from './pages/cadastros/centro-custo/centro-custo.component'
import { PrioridadeComponent } from './pages/cadastros/prioridade/prioridade.component'
import { TipoequipamentoComponent } from './pages/cadastros/tipoequipamento/tipoequipamento.component'
import { HistoricoEquipamentoComponent } from './pages/historico-equipamento/historico-equipamento.component'
import { SatisfacaoServicoComponent } from './pages/satisfacao-servico/satisfacao-servico.component'
import { TipoMaterialComponent } from './pages/cadastros/tipo-material/tipo-material.component'
import { QuantitativoServicosComponent } from './pages/quantitativo-servicos/quantitativo-servicos.component'

import { EquipamentoRdComponent } from './pages/relatorios-diarios-rd/equipamento-rd/equipamento-rd.component'
import { ModelosRdComponent } from './pages/relatorios-diarios-rd/modelos-rd/modelos-rd.component'
import { EmissaoRdComponent } from './pages/relatorios-diarios-rd/emissao-rd/emissao-rd.component'
import { CalendarioMensalComponent } from './pages/os/calendario-mensal/calendario-mensal.component'
import { EntradaMaterialComponent } from './pages/entrada-material/entrada-material.component'
import { EntradasPeriodoComponent } from './pages/entradas-periodo/entradas-periodo.component'
import { TratarOSAvaliadaComponent } from './pages/tratar-osavaliada/tratar-osavaliada.component'
import { VistoDeExecucaoComponent } from './pages/os/visto-de-execucao/visto-de-execucao.component'
import { ValidarOsComponent } from './pages/os/validar-os/validar-os.component'


const routes: Routes = [
  {
    path: '',
    component: PagesLayoutComponent,
    children: [
      { path: '', component: LoginPageComponent, data: { extraParameter: '' } },
    ],
  },
  {
    path: '',
    canActivate: [AuthService],
    component: BaseLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: { extraParameter: 'homeMenu' },
      },
      {
        path: 'usuario',
        component: UsuarioPageComponent,
        data: { extraParameter: 'acessoAoSistema' },
      },
      {
        path: 'emitir-os',
        component: EmitirOSComponent,
        data: { extraParameter: 'ordemservico' },
      },
      {
        path: 'emitir-os-automatica',
        component: EmitirOsAutomaticaComponent,
        data: { extraParameter: 'ordemservico' },
      },
      {
        path: 'tratar-os-avaliada',
        component: TratarOSAvaliadaComponent,
        data: { extraParameter: 'ordemservico' },
      },
        {
        path: 'visto-de-execucao',
        component: VistoDeExecucaoComponent,
        data: { extraParameter: 'ordemservico' },
      },
      {
        path: 'validar-os',
        component: ValidarOsComponent,
        data: { extraParameter: 'ordemservico' },
      },
      {
        path: 'consultar-os',
        component: ConsultarOsComponent,
        data: { extraParameter: 'consultasgerenciais' },
      },
      {
        path: 'historico-equipamento',
        component: HistoricoEquipamentoComponent,
        data: { extraParameter: 'consultasgerenciais' },
      },
      {
        path: 'satisfacao-servico',
        component: SatisfacaoServicoComponent,
        data: { extraParameter: 'consultasgerenciais' },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { extraParameter: 'dashboard' },
      },
      {
        path: 'quantitativo-servico',
        component: QuantitativoServicosComponent,
        data: { extraParameter: 'dashboard' },
      },
      {
        path: 'irregularidade',
        component: IrregularidadeComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'empreiteira',
        component: EmpreiteiraComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'fechar-os',
        component: FecharOsComponent,
        data: { extraParameter: 'ordemservico' },
      },
      {
        path: 'fabricante',
        component: FabricanteComponent,
        data: { extraParameter: 'cadastrosBasicos' },
      },
      {
        path: 'estoque',
        component: EstoqueComponent,
        data: { extraParameter: 'cadastrosBasicos' },
      },
      {
        path: 'material',
        component: MaterialComponent,
        data: { extraParameter: 'estoque-materiais' },
      },
      {
        path: 'tipo-material',
        component: TipoMaterialComponent,
        data: { extraParameter: 'estoque-materiais' },
      },
      {
        path: 'entrada-material',
        component: EntradaMaterialComponent,
        data: { extraParameter: 'estoque-materiais' },
      },
      {
        path: 'entrada-periodo',
        component: EntradasPeriodoComponent,
        data: { extraParameter: 'estoque-materiais' },
      },
      {
        path: 'categoria',
        component: CategoriaComponent,
        data: { extraParameter: 'cadastrosBasicos' },
      },
      {
        path: 'funcionario',
        component: FuncionarioComponent,
        data: { extraParameter: 'cadastrosBasicos' },
      },
      {
        path: 'equipamento',
        component: EquipamentoComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'local',
        component: LocalComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'areatecnica',
        component: AreaTecnicaComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },

      {
        path: 'rotina',
        component: RotinaComponent,
        data: { extraParameter: 'planoBasicoManutencao' },
      },
      {
        path: 'atividade',
        component: AtividadeComponent,
        data: { extraParameter: 'planoBasicoManutencao' },
      },
      {
        path: 'calendario-mensal',
        component: CalendarioMensalComponent,
        data: { extraParameter: 'planoBasicoManutencao' },
      },

      {
        path: 'alterar-senha',
        component: UsuarioAlterarSenhaPageComponent,
        data: { extraParameter: '' },
      },

      {
        path: 'equipamento-rd',
        component: EquipamentoRdComponent,
        data: { extraParameter: 'relatorios-rd' },
      },
      {
        path: 'modelo-rd',
        component: ModelosRdComponent,
        data: { extraParameter: 'relatorios-rd' },
      },
      {
        path: 'emitir-rd',
        component: EmissaoRdComponent,
        data: { extraParameter: 'relatorios-rd' },
      },

      {
        path: 'solicitar-spv',
        component: SolicitarSSComponent,
        data: { extraParameter: 'solicitante' },
        children: [
          { path: '', component: SolicitarSSCadastrarComponent },
          { path: 'cadastrar', component: SolicitarSSCadastrarComponent },
          { path: 'cadastrar/:id', component: SolicitarSSCadastrarComponent },
          { path: 'lista', component: SolicitarSSListaComponent },
        ],
      },
      {
        path: 'acompanhar-spv',
        component: AcompanharSSComponent,
        data: { extraParameter: 'solicitante' },
      },
      {
        path: 'avaliar-spv',
        component: AvaliarSSComponent,
        data: { extraParameter: 'gestorSpv' },
      },
      {
        path: 'programar-servico',
        component: ProgramarServicoComponent,
        data: { extraParameter: 'ordemservico' },
      },

      {
        path: 'solicitar-pt',
        component: SolicitarPtComponent,
        data: { extraParameter: 'solicitantept' },
        children: [
          { path: '', component: CadastrarPTComponent },
          { path: 'cadastrar', component: CadastrarPTComponent },
          { path: 'cadastrar/:id', component: CadastrarPTComponent },
          { path: 'lista', component: ListaPTComponent },
        ],
      },
      {
        path: 'acompanhar-pt',
        component: AcompanharPtComponent,
        data: { extraParameter: 'solicitantept' },
      },
      {
        path: 'funcionalidades',
        component: FuncionalidadesComponent,
        data: { extraParameter: 'acessoAoSistema' },
      },

      {
        path: 'not-authorized',
        component: NotAuthorizedComponent,
        data: { extraParameter: 'acessoAoSistema' },
      },

      {
        path: 'centro-custo',
        component: CentroCustoComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      /*  { path: 'consultar-pbm', component: UnderConstructionComponent, data: { extraParameter: 'consultasgerenciais' } }, */
      {
        path: 'consumo-material',
        component: UnderConstructionComponent,
        data: { extraParameter: 'consultasgerenciais' },
      },
      {
        path: 'historico-funcionarios-he',
        component: UnderConstructionComponent,
        data: { extraParameter: 'consultasgerenciais' },
      },

      {
        path: 'classe-equipamento',
        component: ClasseEquipamentoComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'grupo-local-nivel',
        component: GrupoLocalNivelComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'prioridade',
        component: PrioridadeComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },
      {
        path: 'tipo-equipamento',
        component: TipoequipamentoComponent,
        data: { extraParameter: 'cadastrosEstruturais' },
      },

      {
        path: 'not-found',
        component: NotFoundComponent,
        data: { extraParameter: 'homeMenu' },
      }

    ],
  },

  { path: '**', redirectTo: 'not-found' },
]

/* if (APP_SETTINGS.tipoInstalacao === 'SS' || APP_SETTINGS.tipoInstalacao === 'SSPT')
{ rotasSpv.forEach(r => routes[1].children.push(r)); }
if (APP_SETTINGS.tipoInstalacao === 'PT'  || APP_SETTINGS.tipoInstalacao === 'SSPT') { rotasPT.forEach(r => routes[1].children.push(r)); }

routes.push({ path: '**', redirectTo: 'home' });*/

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
